module.exports = __webpack_public_path__ + "img/bat.29ec75d6.svg";